export default __webpack_public_path__ + "static/0128-c07a59371b34641e3d8fa4fad1906f65.png";